import {
	isSearchCompassPartial,
	isSearchResultJiraIssue,
	type SearchPageEdge,
	type SearchPageResponse,
} from '@atlassian/search-client';

import { ProductKeys } from '../../common/constants/products';
import { getTeamId } from '../../common/utils/teams';

// This function is used to extract the issue keys and teamIds from the search results
export const extractIssueAndTeamsIds = (edges?: SearchPageEdge[]) => {
	// Fetch extra fields for Issues
	const issueKeys: string[] = [];
	// Fetch team names associated with the teamIds in Compass results
	const teamIds: string[] = [];
	if (edges && edges.length > 0) {
		edges.forEach((edge) => {
			if (isSearchResultJiraIssue(edge.node)) {
				const issueKey =
					edge.node.issue?.webUrl?.split('/').at(-1) || edge.node.url.split('/').at(-1);
				if (!!issueKey) {
					issueKeys.push(issueKey);
				}
			} else if (isSearchCompassPartial(edge.node)) {
				const teamId = getTeamId(edge.node.ownerId);
				if (teamId && !teamIds.includes(teamId)) {
					teamIds.push(teamId);
				}
			}
		});
	}
	return { issueKeys, teamIds };
};

/**
 * This function is used to get the count of the selected product
 * The counts returned from ResultsCountQuery/rightPanelQuery should be the source of truth for product counts
 * We should never use the counts returned from SearchPageQuery
 */
export const getProductResultCount = (
	searchQuery: string,
	selectedProduct: ProductKeys,
	searchCountResponse: SearchPageResponse,
) => {
	const counts = searchCountResponse.data?.search?.results.totalCounts || [];

	// Only Confluence allows an empty query so we should only return the count for Confluence
	if (selectedProduct === ProductKeys.Confluence && searchQuery === '') {
		return counts.filter((count) => count.product === ProductKeys.Confluence);
	}

	return counts;
};
